import React from 'react'
import { Grid } from '@mui/material';

const DrawerFooter = ({stylep175, translate, SWVersion}) => {
  const t = (key, fallback) => {
    const value = typeof translate === 'function' ? translate(key) : key;
    return value && value !== key ? value : fallback;
  };
  return (
        <Grid container alignContent='center' style={{height:'10vh', marginTop:'88vh', position: 'absolute', padding: '1vh', borderTop: '1px solid #2f2f2f', }}>
            {/* Contenido del pie de página */}
            <Grid container justifyContent='flex-start' alignContent='center' style={{ height:'1.8vh'}}>
                <p style={{fontWeight:200, fontSize: stylep175,height:'1.3vh'}}> {t('email_label', 'Correo :')} informaciones@itgchile.com</p>
            </Grid>
            <Grid container justifyContent='flex-start' alignContent='center' style={{ height:'1.8vh'}}>
                <p style={{fontWeight:200, fontSize: stylep175,height:'1.3vh'}}> {t('phone_label', 'Fono :')} +56 (65) 22 52 881</p>
            </Grid>
            <Grid container justifyContent='flex-start' alignContent='center' style={{ height:'1.8vh'}}>
                <p style={{fontWeight:200, fontSize: stylep175,height:'1.3vh'}}> {t('phone_label', 'Fono :')} +56 (65) 22 50 080</p>
            </Grid>
            <Grid container justifyContent='flex-start' alignContent='center' style={{ height:'1.8vh'}}>
                <p style={{fontWeight:200, fontSize: stylep175,height:'1.3vh'}}>ITG Chile</p>
            </Grid>
            <Grid container justifyContent='center' alignContent='center' style={{ height:'1.5vh'}}>
                <p style={{fontWeight:200, fontSize: stylep175, height:'1.3vh', color:'rgba(255,255,255)'}}>{SWVersion}</p>
            </Grid>
        </Grid>
   )
}

export default DrawerFooter
